import { render, staticRenderFns } from "./systemQuestionBank.vue?vue&type=template&id=0c3df111&scoped=true&"
import script from "./systemQuestionBank.vue?vue&type=script&lang=js&"
export * from "./systemQuestionBank.vue?vue&type=script&lang=js&"
import style0 from "./systemQuestionBank.vue?vue&type=style&index=0&id=0c3df111&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3df111",
  null
  
)

export default component.exports